<template>
  <div class="referrals-layout">
    <div class="referrals-tab-menu">
      <div class="tab-menu-list">
        <div
          v-for="(item, index) in menuList"
          v-show="menuStatus[item.name]"
          class="tab-menu-item"
          :key="index"
          :ref="`menu_${item.name}`"
          :class="item.name === activeMenuName && 'is-active'"
          @click="handleMenuItemClick(item)"
        >
          <div class="tab-menu-name">{{ $t(item.meta.menuI18nKey) }}</div>
        </div>
        <div class="active-bar">
          <div ref="activeLine" class="active-line" :style="menuActiveLineStyle"></div>
        </div>
      </div>
      <div v-show="showChildMenu" class="child-tab-menu-list">
        <div
          v-for="(item, index) in childMenuList"
          v-show="childMenuStatus[item.name]"
          class="child-tab-menu-item"
          :key="index"
          :class="item.name === activeChildMenuName && 'is-active'"
          @click="handleChildMenuItemClick(item)"
        >
          {{ $t(item.meta.menuI18nKey) }}
        </div>
      </div>
    </div>
    <div class="referrals-content">
      <router-view
        :personalInfo="personalInfo"
        :companyHasReferralPremium="companyHasReferralPremium"
        :companyHasSoftUserPremium="companyHasSoftUserPremium"
        :companyHiddenRewards="companyHiddenRewards"
        :companyHiddenReferralRewards="companyHiddenReferralRewards"
      />
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import * as referralsRoute from '../../referralsRoute'

export default {
  props: {
    personalInfo: {
      required: true
    },
    companyHasReferralPremium: {
      type: Boolean,
      default: true
    },
    companyHasSoftUserPremium: {
      type: Boolean,
      default: true
    },
    companyHiddenRewards: {
      type: Boolean,
      default: false
    },
    companyHiddenReferralRewards: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      activeMenuName: '',
      activeChildMenuName: '',
      menuActiveLineStyle: {}
    }
  },
  computed: {
    menuList () {
      const routes = [
        referralsRoute.leadsRoute,
        referralsRoute.dashboardRoute
      ]
      if (this.companyHasReferralPremium && !this.companyHiddenRewards && !this.companyHiddenReferralRewards) {
        routes.push(referralsRoute.rewardsRoute)
      }
      if (this.personalInfo?.employee) {
        routes.push(referralsRoute.leaderBoardRoute)
      }
      return routes
    },
    menuStatus () {
      const status = {}
      _.forEach(this.menuList, (item) => {
        status[item.name] = true
      })
      const rewardsRoute = referralsRoute.rewardsRoute
      if (!this.companyHasReferralPremium || this.companyHiddenRewards) {
        status[rewardsRoute.name] = false
      }
      return status
    },
    showChildMenu () {
      return this.childMenuList.length > 0
    },
    childMenuList () {
      const activeMenu = _.find(this.menuList, { name: this.activeMenuName })
      return activeMenu?.children || []
    },
    childMenuStatus () {
      const status = {}
      _.forEach(this.childMenuList, (item) => {
        status[item.name] = true
      })
      const leadsRoute = referralsRoute.leadsRoute
      if (this.activeMenuName === leadsRoute.name && !this.companyHasSoftUserPremium) {
        status[leadsRoute.children[0].name] = false
      }
      return status
    }
  },
  created () {
    this.refreshActiveMenuName(null, false)
    this.refreshActiveMenuName(null, true)
    this.redirectHiddenMenu()
  },
  methods: {
    refreshActiveMenuName (currentRoute, isChildMenu) {
      currentRoute = currentRoute || this.$route
      let foundName = null
      const routeName = currentRoute.name
      const menuList = isChildMenu ? this.childMenuList : this.menuList
      _.forEach(menuList, (menuItem) => {
        const menuItemName = menuItem.name
        if (menuItemName === routeName) {
          foundName = menuItemName
        } else if (menuItem.children) {
          const childMenu = _.find(menuItem.children, { name: routeName })
          if (childMenu) {
            foundName = menuItem.name
          }
        }
        return !foundName
      })
      if (foundName) {
        if (isChildMenu) {
          this.activeChildMenuName = foundName
        } else {
          this.activeMenuName = foundName
        }
      } else {
        const parentRoute = currentRoute.meta?._parent
        if (parentRoute) {
          this.refreshActiveMenuName(parentRoute, isChildMenu)
        }
      }
    },
    redirectHiddenMenu () {
      const leadsRoute = referralsRoute.leadsRoute
      const rewardsRoute = referralsRoute.rewardsRoute
      const potentialLeadsRoute = leadsRoute.children[0]
      const appliedLeadsRoute = leadsRoute.children[1]
      if (this.activeMenuName === leadsRoute.name) {
        if (!this.companyHasSoftUserPremium && this.activeChildMenuName === potentialLeadsRoute.name) {
          this.handleChildMenuItemClick(appliedLeadsRoute)
        }
      } else if (this.activeMenuName === rewardsRoute.name) {
        if (!this.companyHasReferralPremium) {
          if (this.companyHasSoftUserPremium) {
            this.handleChildMenuItemClick(potentialLeadsRoute)
          } else {
            this.handleChildMenuItemClick(appliedLeadsRoute)
          }
        }
      }
    },
    async refreshActiveMenuLine () {
      let activeMenuEl = this.$refs[`menu_${this.activeMenuName}`]
      if (!activeMenuEl) {
        await new Promise((resolve, reject) => {
          this.$nextTick(() => {
            activeMenuEl = this.$refs[`menu_${this.activeMenuName}`]
            resolve()
          })
        })
      }
      if (!activeMenuEl) {
        return
      }
      activeMenuEl = activeMenuEl[0]
      const activeLineEl = this.$refs.activeLine
      const translateX = activeMenuEl.offsetLeft + (activeMenuEl.clientWidth / 2) - (activeLineEl.clientWidth / 2)
      this.menuActiveLineStyle = {
        transform: `translateX(${translateX}px)`
      }
    },
    handleMenuItemClick (menuItem) {
      this.$router.push({ path: menuItem.path, query: this.$route.query })
    },
    handleChildMenuItemClick (childMenuItem) {
      this.$router.push({ path: childMenuItem.path, query: this.$route.query })
    }
  },
  watch: {
    $route () {
      this.refreshActiveMenuName(null, false)
      this.refreshActiveMenuName(null, true)
      this.redirectHiddenMenu()
    },
    menuStatus () {
      this.redirectHiddenMenu()
    },
    childMenuStatus () {
      this.redirectHiddenMenu()
    },
    activeMenuName () {
      this.refreshActiveMenuLine()
    },
    menuList () {
      this.$nextTick(this.refreshActiveMenuLine)
    }
  }
}
</script>

<style lang="scss" scoped>
.referrals-layout {
  .referrals-tab-menu {

    .tab-menu-list {
      display: flex;
      padding-bottom: 12px;
      overflow: hidden;
      position: relative;

      .tab-menu-item {
        flex: 1;
        border-left: 1px solid #aaaaaa;
        font-size: 16px;
        color: #aaaaaa;
        cursor: pointer;

        &:first-child {
          border-left: 0;
        }

        &.is-active {
          color: #333333;
        }

        .tab-menu-name {
          padding: 0 5px;
          overflow: hidden;
          white-space: nowrap;
          word-break: keep-all;
          text-overflow: ellipsis;
          text-align: center;
        }
      }

      .active-bar {
        width: 100%;
        height: 2px;
        position: absolute;
        bottom: 5px;
        left: 0;

        .active-line {
          width: 40px;
          height: 100%;
          background: var(--custom-color);
          transition: all .3s ease;
        }
      }
    }

    .child-tab-menu-list {
      display: flex;
      margin-top: 10px;
      padding: 0 12px;
      background: #b3b3b3;
      color: #fff;

      .child-tab-menu-item {
        padding: 5px 10px;
        font-size: 14px;
        cursor: pointer;

        &.is-active {
          background: #e5e5e5;
          color: #333333;
        }
      }
    }
  }

  .referrals-content {
    margin-top: 20px;
    padding: 0 20px;
  }
}
</style>
